<template>
    <ModalTemplate @close="$emit('close')"> 
        <template v-slot:header>
            <h4 class="h4">Чтобы удалить аккаунт, введите ваш пароль</h4>
        </template>
        <template v-slot:body>
            <div class="deleting-body">
                <input class="input" type="password" placeholder="Пароль" v-model="password">
                <div class="button red" @click="deleteAccount()">
                    <Loader :color="'red'" v-if="loading" />
                    <p v-else >Удалить</p>
                </div>
            </div>
        </template>

    </ModalTemplate>
</template>
<script>
import PushService from '@/config/firebase_push.js'

export default {
    name: 'DeleteAccount',
    data: () => {
        return {
            loading: false,
            password: ''
        }
    },
    components: {
        ModalTemplate: () => import('@/components/Templates/Modal'),
        Loader: () => import('@/components/UI/Loader'),
    },
    methods: {
        async deleteAccount() {
            if (this.password && this.password.length > 0) {
                this.loading = true
                await this.$axios.post('api/account/delete', {password: this.password})
                    .then(() => {
                        this.loading = false;
                        this.$store.dispatch('addNotification', {message: 'Ваш акканут был удалён!'})
                        this.logout()
                    })
                    .catch(() => {
                        this.loading = false
                        this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
                    })
            } else {
                this.$store.dispatch('addError', {message: 'Введите ваш пароль'})
            }
        },
        async logout() {
            PushService.deleteToken()
            this.$socket.disconnect();
            this.$store.dispatch('logout')
            this.$router.push('/login');
            this.$router.go();
        },
    }
}
</script>
<style lang="stylus">
.deleting-body
    width 100%
    display flex
    flex-direction column
    align-items flex-end
    .input
        width 100%
    .button
        margin-top 15px
</style>